export const json = {
  "code": 200,
  "data": [{
    "button": null,
    "children": [{
      "button": null,
      "children": [{
        "button": null,
        "children": [{
          "button": {
            "id": "11",
            "moveDown": 200,
            "name": "1#储能柜",
            "type": 1,
            "url": "xxx",
            "width": 60
          },
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 32,
              "field": "CEPa.EP02A1.BSMU.Stack.StackSOC",
              "id": 33,
              "image": "",
              "imageSizes": "",
              "name": "SOC",
              "nameType": 1,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 8,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 32,
              "field": "CEPa.EP02A1.BSMU.Stack.StackVolt",
              "id": 34,
              "image": "",
              "imageSizes": "",
              "name": "组端电压",
              "nameType": 1,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 12,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 32,
              "field": "CEPa.EP02A1.BSMU.Stack.StackCurr",
              "id": 35,
              "image": "",
              "imageSizes": "",
              "name": "组端电流",
              "nameType": 1,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 13,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 32,
              "field": "CEPa.EP02A1.BMS.Summary.MaxV1",
              "id": 36,
              "image": "",
              "imageSizes": "",
              "name": "最高单体电压",
              "nameType": 1,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 14,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 32,
              "field": "CEPa.EP02A1.BMS.Summary.MinV1",
              "id": 37,
              "image": "",
              "imageSizes": "",
              "name": "最低单体电压",
              "nameType": 1,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 15,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 32,
              "field": "CEPa.EP02A1.BMS.Summary.MaxT1",
              "id": 38,
              "image": "",
              "imageSizes": "",
              "name": "最高单体温度",
              "nameType": 1,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 16,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 32,
              "field": "CEPa.EP02A1.BMS.Summary.MinT1",
              "id": 39,
              "image": "",
              "imageSizes": "",
              "name": "最低单体温度",
              "nameType": 1,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 17,
              "unit": "",
              "value": "0"
            }]
          ],
          "groupSizes": "120,120",
          "id": "32",
          "image": "battery",
          "imageSizes": "23,29",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#FF0000",
            "linelength": 100,
            "linestatus": "0",
            "linetype": 0
          },
          "name": "1#电池簇",
          "nameType": 1,
          "type": 208
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 7,
            "field": "CEPa.EP02A1.PCS.YC.Analog_ActivePower_3Phase",
            "id": 12,
            "image": "",
            "imageSizes": "",
            "name": "有功功率(kW)",
            "nameType": 1,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 3,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 7,
            "field": "CEPa.EP02A1.PCS.YC.InvOutVoltAB",
            "id": 13,
            "image": "",
            "imageSizes": "",
            "name": "相电压(V)",
            "nameType": 1,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 4,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#09FF0C",
            "dataType": 2,
            "desc": "正常",
            "equipLogicId": 7,
            "field": "CEPa.EP02A1.PCS.Status.FaultStatus",
            "id": 14,
            "image": "",
            "imageSizes": "",
            "name": "故障状态",
            "nameType": 1,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 5,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#09FF0C",
            "dataType": 2,
            "desc": "开启",
            "equipLogicId": 7,
            "field": "CEPa.EP02A1.PCS.Status.OnOffStatus",
            "id": 15,
            "image": "",
            "imageSizes": "",
            "name": "运行状态",
            "nameType": 1,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 6,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#00CEAE",
            "dataType": 2,
            "desc": "远程",
            "equipLogicId": 7,
            "field": "CEPc.EP03B2.PCS.Status.Sys.LocalRemote",
            "id": 16,
            "image": "",
            "imageSizes": "",
            "name": "运行模式",
            "nameType": 1,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 35,
            "unit": "",
            "value": "0"
          }]
        ],
        "groupSizes": "160,120",
        "id": "7",
        "image": "cabinet",
        "imageSizes": "41,57",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 80,
          "linestatus": "",
          "linetype": 1
        },
        "name": "1#储能柜",
        "nameType": 0,
        "type": 206
      }, {
        "button": null,
        "children": [{
          "button": {
            "id": "12",
            "moveDown": 200,
            "name": "2#储能柜",
            "type": 1,
            "url": "xxx",
            "width": 60
          },
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 33,
              "field": "CEPb.EP02A2.BSMU.Stack.StackSOC",
              "id": 40,
              "image": "",
              "imageSizes": "",
              "name": "SOC",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 8,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 33,
              "field": "CEPb.EP02A2.BSMU.Stack.StackVolt",
              "id": 41,
              "image": "",
              "imageSizes": "",
              "name": "组端电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 12,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 33,
              "field": "CEPb.EP02A2.BSMU.Stack.StackCurr",
              "id": 42,
              "image": "",
              "imageSizes": "",
              "name": "组端电流",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 13,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 33,
              "field": "CEPb.EP02A2.BMS.Summary.MaxV1",
              "id": 43,
              "image": "",
              "imageSizes": "",
              "name": "最高单体电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 14,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 33,
              "field": "CEPb.EP02A2.BMS.Summary.MinV1",
              "id": 44,
              "image": "",
              "imageSizes": "",
              "name": "最低单体电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 15,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 33,
              "field": "CEPb.EP02A2.BMS.Summary.MaxT1",
              "id": 45,
              "image": "",
              "imageSizes": "",
              "name": "最高单体温度",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 16,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 33,
              "field": "CEPb.EP02A2.BMS.Summary.MinT1",
              "id": 46,
              "image": "",
              "imageSizes": "",
              "name": "最低单体温度",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 17,
              "unit": "",
              "value": "0"
            }]
          ],
          "groupSizes": "120,120",
          "id": "33",
          "image": "battery",
          "imageSizes": "23,29",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#FF0000",
            "linelength": 100,
            "linestatus": "0",
            "linetype": 0
          },
          "name": "2#电池簇",
          "nameType": 1,
          "type": 208
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 8,
            "field": "CEPb.EP02A2.PCS.YC.Analog_ActivePower_3Phase",
            "id": 17,
            "image": "",
            "imageSizes": "",
            "name": "有功功率(kW)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 3,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 8,
            "field": "CEPb.EP02A2.PCS.YC.InvOutVoltAB",
            "id": 18,
            "image": "",
            "imageSizes": "",
            "name": "相电压(V)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 4,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#09FF0C",
            "dataType": 2,
            "desc": "正常",
            "equipLogicId": 8,
            "field": "CEPb.EP02A2.PCS.Status.FaultStatus",
            "id": 19,
            "image": "",
            "imageSizes": "",
            "name": "故障状态",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 5,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#09FF0C",
            "dataType": 2,
            "desc": "开启",
            "equipLogicId": 8,
            "field": "CEPb.EP02A2.PCS.Status.OnOffStatus",
            "id": 20,
            "image": "",
            "imageSizes": "",
            "name": "运行状态",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 6,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#00CEAE",
            "dataType": 2,
            "desc": "远程",
            "equipLogicId": 8,
            "field": "CEPc.EP03B2.PCS.Status.Sys.LocalRemote",
            "id": 21,
            "image": "",
            "imageSizes": "",
            "name": "运行模式",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 35,
            "unit": "",
            "value": "0"
          }]
        ],
        "groupSizes": "160,120",
        "id": "8",
        "image": "cabinet",
        "imageSizes": "41,57",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 80,
          "linestatus": "",
          "linetype": 1
        },
        "name": "2#储能柜",
        "nameType": 0,
        "type": 206
      }, {
        "button": null,
        "children": [{
          "button": {
            "id": "13",
            "moveDown": 200,
            "name": "3#储能柜",
            "type": 1,
            "url": "xxx",
            "width": 60
          },
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 34,
              "field": "CEPc.EP03B1.BMS.Pack.SOC",
              "id": 47,
              "image": "",
              "imageSizes": "",
              "name": "SOC",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 8,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 34,
              "field": "CEPc.EP03B1.BMS.Pack.PackV",
              "id": 48,
              "image": "",
              "imageSizes": "",
              "name": "组端电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 12,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 34,
              "field": "CEPc.EP03B1.BMS.Pack.PackCur",
              "id": 49,
              "image": "",
              "imageSizes": "",
              "name": "组端电流",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 13,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 34,
              "field": "CEPc.EP03B1.BMS.Summary.MaxV1",
              "id": 50,
              "image": "",
              "imageSizes": "",
              "name": "最高单体电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 14,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 34,
              "field": "CEPc.EP03B1.BMS.Summary.MinV1",
              "id": 51,
              "image": "",
              "imageSizes": "",
              "name": "最低单体电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 15,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 34,
              "field": "CEPc.EP03B1.BMS.Summary.MaxT1",
              "id": 52,
              "image": "",
              "imageSizes": "",
              "name": "最高单体温度",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 16,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 34,
              "field": "CEPc.EP03B1.BMS.Summary.MinT1",
              "id": 53,
              "image": "",
              "imageSizes": "",
              "name": "最低单体温度",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 17,
              "unit": "",
              "value": "0"
            }]
          ],
          "groupSizes": "120,120",
          "id": "34",
          "image": "battery",
          "imageSizes": "23,29",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#FF0000",
            "linelength": 100,
            "linestatus": "0",
            "linetype": 0
          },
          "name": "3#电池簇",
          "nameType": 1,
          "type": 208
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 9,
            "field": "CEPc.EP03B1.PCS.Data.Sys.PCS_P",
            "id": 22,
            "image": "",
            "imageSizes": "",
            "name": "有功功率(kW)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 3,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 9,
            "field": "CEPc.EP03B1.PCS.Data.Sys.PCS_Ua",
            "id": 23,
            "image": "",
            "imageSizes": "",
            "name": "相电压(V)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 4,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#09FF0C",
            "dataType": 2,
            "desc": "正常",
            "equipLogicId": 9,
            "field": "CEPc.EP03B1.PCS.Status.Sys.ErrState",
            "id": 24,
            "image": "",
            "imageSizes": "",
            "name": "故障状态",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 5,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#09FF0C",
            "dataType": 2,
            "desc": "开启",
            "equipLogicId": 9,
            "field": "CEPc.EP03B1.PCS.Status.Sys.LocalRemote",
            "id": 25,
            "image": "",
            "imageSizes": "",
            "name": "运行状态",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 6,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#00CEAE",
            "dataType": 2,
            "desc": "远程",
            "equipLogicId": 9,
            "field": "CEPc.EP03B1.BMS.DIDO.DI_MPContactorState",
            "id": 26,
            "image": "",
            "imageSizes": "",
            "name": "运行模式",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 35,
            "unit": "",
            "value": "0"
          }]
        ],
        "groupSizes": "160,120",
        "id": "9",
        "image": "cabinet",
        "imageSizes": "41,57",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 80,
          "linestatus": "",
          "linetype": 1
        },
        "name": "3#储能柜",
        "nameType": 0,
        "type": 206
      }, {
        "button": null,
        "children": [{
          "button": {
            "id": "14",
            "moveDown": 200,
            "name": "4#储能柜",
            "type": 1,
            "url": "xxx",
            "width": 60
          },
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 35,
              "field": "CEPd.EP03B2.BMS.Pack.SOC",
              "id": 54,
              "image": "",
              "imageSizes": "",
              "name": "SOC",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 8,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 35,
              "field": "CEPd.EP03B2.BMS.Pack.PackV",
              "id": 55,
              "image": "",
              "imageSizes": "",
              "name": "组端电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 12,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 35,
              "field": "CEPd.EP03B2.BMS.Pack.PackCur",
              "id": 56,
              "image": "",
              "imageSizes": "",
              "name": "组端电流",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 13,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 35,
              "field": "CEPd.EP03B2.BMS.Summary.MaxV1",
              "id": 57,
              "image": "",
              "imageSizes": "",
              "name": "最高单体电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 14,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 35,
              "field": "CEPd.EP03B2.BMS.Summary.MinV1",
              "id": 58,
              "image": "",
              "imageSizes": "",
              "name": "最低单体电压",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 15,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 35,
              "field": "CEPd.EP03B2.BMS.Summary.MaxT1",
              "id": 59,
              "image": "",
              "imageSizes": "",
              "name": "最高单体温度",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 16,
              "unit": "",
              "value": "0"
            }],
            [{
              "color": "#FFB202",
              "dataType": 1,
              "desc": "",
              "equipLogicId": 35,
              "field": "CEPd.EP03B2.BMS.Summary.MinT1",
              "id": 60,
              "image": "",
              "imageSizes": "",
              "name": "最低单体温度",
              "nameType": 0,
              "position": "down",
              "range": "",
              "showOrder": 1,
              "status": "",
              "style": 5,
              "type": 17,
              "unit": "",
              "value": "0"
            }]
          ],
          "groupSizes": "120,120",
          "id": "35",
          "image": "battery",
          "imageSizes": "23,29",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#FF0000",
            "linelength": 100,
            "linestatus": "0",
            "linetype": 0
          },
          "name": "4#电池簇",
          "nameType": 1,
          "type": 208
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 10,
            "field": "CEPd.EP03B2.PCS.Data.Sys.PCS_P",
            "id": 27,
            "image": "",
            "imageSizes": "",
            "name": "有功功率(kW)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 3,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 10,
            "field": "CEPd.EP03B2.PCS.Data.Sys.PCS_Ua",
            "id": 28,
            "image": "",
            "imageSizes": "",
            "name": "相电压(V)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 4,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#09FF0C",
            "dataType": 2,
            "desc": "正常",
            "equipLogicId": 10,
            "field": "CEPd.EP03B2.PCS.Status.Sys.ErrState",
            "id": 29,
            "image": "",
            "imageSizes": "",
            "name": "故障状态",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 5,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#09FF0C",
            "dataType": 2,
            "desc": "开启",
            "equipLogicId": 10,
            "field": "CEPd.EP03B2.PCS.Status.Sys.LocalRemote",
            "id": 30,
            "image": "",
            "imageSizes": "",
            "name": "运行状态",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 6,
            "unit": "",
            "value": "0"
          }],
          [{
            "color": "#00CEAE",
            "dataType": 2,
            "desc": "远程",
            "equipLogicId": 10,
            "field": "CEPd.EP03B2.BMS.DIDO.DI_MPContactorState",
            "id": 31,
            "image": "",
            "imageSizes": "",
            "name": "运行模式",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 4,
            "type": 35,
            "unit": "",
            "value": "0"
          }]
        ],
        "groupSizes": "160,120",
        "id": "10",
        "image": "cabinet",
        "imageSizes": "41,57",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 80,
          "linestatus": "",
          "linetype": 1
        },
        "name": "4#储能柜",
        "nameType": 0,
        "type": 206
      }, {
        "button": null,
        "children": [],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 11,
            "field": "fuzai1",
            "id": 32,
            "image": "power-yellow",
            "imageSizes": "20,22",
            "name": "功率(kW)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 1,
            "type": 38,
            "unit": "",
            "value": "0"
          }]
        ],
        "groupSizes": "160,0",
        "id": "11",
        "image": "load",
        "imageSizes": "59,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 0
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "负载",
        "nameType": 0,
        "type": 207
      }],
      "emsId": 0,
      "fieldGroup": "",
      "fields": [],
      "groupSizes": "240,120",
      "id": "2",
      "image": "changer",
      "imageSizes": "56,56",
      "include": [],
      "includeVo": null,
      "level": 2,
      "lineDown": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 50,
        "linestatus": "",
        "linetype": 1
      },
      "lineUp": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 30,
        "linestatus": "",
        "linetype": 1
      },
      "name": "TR04",
      "nameType": 0,
      "type": 216
    }, {
      "button": null,
      "children": [{
        "button": {
          "id": "11",
          "moveDown": 50,
          "name": "负载电表",
          "type": 1,
          "url": "xxx",
          "width": 60
        },
        "children": [],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 12,
            "field": "fuzai2",
            "id": 61,
            "image": "power-yellow",
            "imageSizes": "20,22",
            "name": "功率(kW)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 1,
            "type": 38,
            "unit": "",
            "value": "0"
          }]
        ],
        "groupSizes": "160,0",
        "id": "12",
        "image": "load",
        "imageSizes": "59,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 0
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "负载",
        "nameType": 0,
        "type": 207
      }],
      "emsId": 0,
      "fieldGroup": "",
      "fields": [],
      "groupSizes": "120,120",
      "id": "3",
      "image": "changer",
      "imageSizes": "56,56",
      "include": [],
      "includeVo": null,
      "level": 2,
      "lineDown": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 50,
        "linestatus": "",
        "linetype": 1
      },
      "lineUp": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 30,
        "linestatus": "",
        "linetype": 1
      },
      "name": "TR01",
      "nameType": 0,
      "type": 216
    }, {
      "button": null,
      "children": [{
        "button": {
          "id": "11",
          "moveDown": 50,
          "name": "负载电表",
          "type": 1,
          "url": "xxx",
          "width": 60
        },
        "children": [],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 13,
            "field": "fuzai3",
            "id": 62,
            "image": "power-yellow",
            "imageSizes": "20,22",
            "name": "功率(kW)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 1,
            "type": 38,
            "unit": "",
            "value": "0"
          }]
        ],
        "groupSizes": "160,0",
        "id": "13",
        "image": "load",
        "imageSizes": "59,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 0
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "负载",
        "nameType": 0,
        "type": 207
      }],
      "emsId": 0,
      "fieldGroup": "",
      "fields": [],
      "groupSizes": "120,120",
      "id": "4",
      "image": "changer",
      "imageSizes": "56,56",
      "include": [],
      "includeVo": null,
      "level": 2,
      "lineDown": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 50,
        "linestatus": "",
        "linetype": 1
      },
      "lineUp": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 30,
        "linestatus": "",
        "linetype": 1
      },
      "name": "TR02",
      "nameType": 0,
      "type": 216
    }, {
      "button": null,
      "children": [{
        "button": {
          "id": "11",
          "moveDown": 50,
          "name": "负载电表",
          "type": 1,
          "url": "xxx",
          "width": 60
        },
        "children": [],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [
          [{
            "color": "#FFB202",
            "dataType": 1,
            "desc": "",
            "equipLogicId": 14,
            "field": "fuzai4",
            "id": 63,
            "image": "power-yellow",
            "imageSizes": "20,22",
            "name": "功率(kW)",
            "nameType": 0,
            "position": "right",
            "range": "",
            "showOrder": 1,
            "status": "",
            "style": 1,
            "type": 38,
            "unit": "",
            "value": "0"
          }]
        ],
        "groupSizes": "160,0",
        "id": "14",
        "image": "load",
        "imageSizes": "59,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 0
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "负载",
        "nameType": 0,
        "type": 207
      }],
      "emsId": 0,
      "fieldGroup": "",
      "fields": [],
      "groupSizes": "120,120",
      "id": "5",
      "image": "changer",
      "imageSizes": "56,56",
      "include": [],
      "includeVo": null,
      "level": 2,
      "lineDown": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 50,
        "linestatus": "",
        "linetype": 1
      },
      "lineUp": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 30,
        "linestatus": "",
        "linetype": 1
      },
      "name": "TR03",
      "nameType": 0,
      "type": 216
    }, {
      "button": null,
      "children": [{
        "button": null,
        "children": [{
          "button": null,
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [],
          "groupSizes": "160,120",
          "id": "20",
          "image": "solar2",
          "imageSizes": "61,50",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 1
          },
          "name": "光伏",
          "nameType": 0,
          "type": 213
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [],
        "groupSizes": "120,120",
        "id": "15",
        "image": "changer",
        "imageSizes": "56,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "光伏变压器",
        "nameType": 0,
        "type": 216
      }, {
        "button": null,
        "children": [{
          "button": null,
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [],
          "groupSizes": "120,120",
          "id": "21",
          "image": "solar2",
          "imageSizes": "61,50",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 1
          },
          "name": "光伏",
          "nameType": 0,
          "type": 213
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [],
        "groupSizes": "120,120",
        "id": "16",
        "image": "changer",
        "imageSizes": "56,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "光伏变压器",
        "nameType": 0,
        "type": 216
      }, {
        "button": null,
        "children": [{
          "button": null,
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [],
          "groupSizes": "120,120",
          "id": "22",
          "image": "solar2",
          "imageSizes": "61,50",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 1
          },
          "name": "光伏",
          "nameType": 0,
          "type": 213
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [],
        "groupSizes": "120,120",
        "id": "17",
        "image": "changer",
        "imageSizes": "56,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "光伏变压器",
        "nameType": 0,
        "type": 216
      }, {
        "button": null,
        "children": [{
          "button": null,
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [],
          "groupSizes": "120,120",
          "id": "23",
          "image": "solar2",
          "imageSizes": "61,50",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 1
          },
          "name": "光伏",
          "nameType": 0,
          "type": 213
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [],
        "groupSizes": "120,120",
        "id": "18",
        "image": "changer",
        "imageSizes": "56,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "光伏变压器",
        "nameType": 0,
        "type": 216
      }, {
        "button": null,
        "children": [{
          "button": null,
          "children": [],
          "emsId": 0,
          "fieldGroup": "",
          "fields": [],
          "groupSizes": "120,120",
          "id": "24",
          "image": "solar2",
          "imageSizes": "61,50",
          "include": [],
          "includeVo": null,
          "level": 4,
          "lineDown": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 0
          },
          "lineUp": {
            "arrow": "0",
            "linecolor": "#F5AF23",
            "linelength": 50,
            "linestatus": "",
            "linetype": 1
          },
          "name": "光伏",
          "nameType": 0,
          "type": 213
        }],
        "emsId": 0,
        "fieldGroup": "",
        "fields": [],
        "groupSizes": "120,120",
        "id": "19",
        "image": "changer",
        "imageSizes": "56,56",
        "include": [],
        "includeVo": null,
        "level": 3,
        "lineDown": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "lineUp": {
          "arrow": "0",
          "linecolor": "#F5AF23",
          "linelength": 50,
          "linestatus": "",
          "linetype": 1
        },
        "name": "光伏变压器",
        "nameType": 0,
        "type": 216
      }],
      "emsId": 0,
      "fieldGroup": "",
      "fields": [],
      "groupSizes": "120,70",
      "id": "6",
      "image": "ammeter",
      "imageSizes": "44,44",
      "include": [],
      "includeVo": null,
      "level": 2,
      "lineDown": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 50,
        "linestatus": "",
        "linetype": 1
      },
      "lineUp": {
        "arrow": "0",
        "linecolor": "#F5AF23",
        "linelength": 30,
        "linestatus": "",
        "linetype": 1
      },
      "name": "光伏电表",
      "nameType": 0,
      "type": 211
    }],
    "emsId": 0,
    "fieldGroup": "",
    "fields": [
      [{
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.Ua",
        "id": 1,
        "image": "v-yellow",
        "imageSizes": "20,22",
        "name": "三相电压",
        "nameType": 1,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 44,
        "unit": "",
        "value": "0"
      }, {
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.Ub",
        "id": 2,
        "image": "v-yellow",
        "imageSizes": "20,22",
        "name": "三相电压",
        "nameType": 0,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 45,
        "unit": "",
        "value": "0"
      }, {
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.Uc",
        "id": 3,
        "image": "v-yellow",
        "imageSizes": "20,22",
        "name": "三相电压",
        "nameType": 0,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 46,
        "unit": "",
        "value": "0"
      }],
      [{
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.Ia",
        "id": 4,
        "image": "a-yellow",
        "imageSizes": "20,22",
        "name": "三相电流",
        "nameType": 1,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 47,
        "unit": "",
        "value": "0"
      }, {
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.Ib",
        "id": 5,
        "image": "a-yellow",
        "imageSizes": "20,22",
        "name": "三相电流",
        "nameType": 0,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 48,
        "unit": "",
        "value": "0"
      }, {
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.Ic",
        "id": 6,
        "image": "a-yellow",
        "imageSizes": "20,22",
        "name": "三相电流",
        "nameType": 0,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 49,
        "unit": "",
        "value": "0"
      }],
      [{
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.PFa",
        "id": 7,
        "image": "power-factor",
        "imageSizes": "20,22",
        "name": "三相功率因数",
        "nameType": 1,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 40,
        "unit": "",
        "value": "0"
      }, {
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.PFb",
        "id": 8,
        "image": "power-factor",
        "imageSizes": "20,22",
        "name": "三相功率因数",
        "nameType": 0,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 41,
        "unit": "",
        "value": "0"
      }, {
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.PFc",
        "id": 9,
        "image": "power-factor",
        "imageSizes": "20,22",
        "name": "三相功率因数",
        "nameType": 0,
        "position": "left",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 41,
        "unit": "",
        "value": "0"
      }],
      [{
        "color": "#FFB202",
        "dataType": 1,
        "desc": "",
        "equipLogicId": 1,
        "field": "CHVa.HVM1.Meter584.rtData.P",
        "id": 10,
        "image": "power-yellow",
        "imageSizes": "20,22",
        "name": "总有功功率",
        "nameType": 1,
        "position": "right",
        "range": "",
        "showOrder": 1,
        "status": "",
        "style": 1,
        "type": 38,
        "unit": "",
        "value": "0"
      }]
    ],
    "groupSizes": "340,120",
    "id": "1",
    "image": "ammeter",
    "imageSizes": "44,44",
    "include": [],
    "includeVo": null,
    "level": 1,
    "lineDown": {
      "arrow": "0",
      "linecolor": "#F5AF23",
      "linelength": 50,
      "linestatus": "",
      "linetype": 1
    },
    "lineUp": {
      "arrow": "0",
      "linecolor": "#F5AF23",
      "linelength": 50,
      "linestatus": "",
      "linetype": 1
    },
    "name": "高压电表",
    "nameType": 0,
    "type": 215
  }],
  "msg": "OK"
}



// WEBPACK FOOTER //
// ./src/components/jsontest.js